export const getPlanAmountFromName = (name) => {
  if (!name) {
    return '';
  }

  name = name.toLowerCase();

  if (getIsParkingPlan(name)) {
    return 'Parking';
  }

  if (getIsUnlimPlan(name)) {
    return 'Unlimited';
  }

  if (name.includes('device rental') || name.includes('pending activation')) {
    return 'New Line';
  }

  const regex = /(\d+)\s*GB/gi;
  const matches = Array.from(name.matchAll(regex));

  if (matches?.[0]?.[1]) {
    return Number(matches[0][1]);
  } else {
    return '';
  }
};

export const getIsUnlimPlan = (name) => {
  if (!name) return false;
  return name.includes('unlimited');
};

export const getIsParkingPlan = (name) => {
  if (!name) return false;
  return name.includes('parking');
};
